export class GeaMissingTranslationHandler {
  devLang = 'dv-DV';
  handle(params) {
    const currentLang = params.translateService.currentLang;
    if (currentLang === this.devLang) {
      return params.key;
    }
    const defaultTranslations = params.translateService.translations[params.translateService.defaultLang] ?? {};
    return defaultTranslations[params.key] ?? params.key;
  }
}
